<template>

    <indica-form
      ref="businessForm"
      :show-edit="false"
      :show-return="false"
      :show-many="false"
      label-prefix="label_"
      table-name="Business"
      :save-to-store="true"
      :group-by-category="true"
      store-name="business"
      :show-submit="false"
      title-label="label_administration_wizard_Business"
      description-label="label_administration_wizard_Business_description"
    />

</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import IndicaForm from "@/utils/forms/indica-form";

export default {
  name: "CreateBusinessTab",
  components: {
    IndicaForm,
  },
  data() {
    return {
      defaultTags: [],
    };
  },
  watch: {},
  methods: {
  },
  computed: {
    ...mapGetters([
      "getTagsToCreate",
      "getAllStoreInfo"
    ]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
